function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilm = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 46 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.149,11.275C4.149,8.793 6.167,6.775 8.649,6.775L35.649,6.775C38.131,6.775 40.149,8.793 40.149,11.275L40.149,33.775C40.149,36.257 38.131,38.275 35.649,38.275L8.649,38.275C6.167,38.275 4.149,36.257 4.149,33.775L4.149,11.275ZM7.524,30.4L7.524,32.65C7.524,33.269 8.03,33.775 8.649,33.775L10.899,33.775C11.518,33.775 12.024,33.269 12.024,32.65L12.024,30.4C12.024,29.781 11.518,29.275 10.899,29.275L8.649,29.275C8.03,29.275 7.524,29.781 7.524,30.4ZM33.399,29.275C32.78,29.275 32.274,29.781 32.274,30.4L32.274,32.65C32.274,33.269 32.78,33.775 33.399,33.775L35.649,33.775C36.268,33.775 36.774,33.269 36.774,32.65L36.774,30.4C36.774,29.781 36.268,29.275 35.649,29.275L33.399,29.275ZM7.524,21.4L7.524,23.65C7.524,24.269 8.03,24.775 8.649,24.775L10.899,24.775C11.518,24.775 12.024,24.269 12.024,23.65L12.024,21.4C12.024,20.781 11.518,20.275 10.899,20.275L8.649,20.275C8.03,20.275 7.524,20.781 7.524,21.4ZM33.399,20.275C32.78,20.275 32.274,20.781 32.274,21.4L32.274,23.65C32.274,24.269 32.78,24.775 33.399,24.775L35.649,24.775C36.268,24.775 36.774,24.269 36.774,23.65L36.774,21.4C36.774,20.781 36.268,20.275 35.649,20.275L33.399,20.275ZM7.524,12.4L7.524,14.65C7.524,15.269 8.03,15.775 8.649,15.775L10.899,15.775C11.518,15.775 12.024,15.269 12.024,14.65L12.024,12.4C12.024,11.781 11.518,11.275 10.899,11.275L8.649,11.275C8.03,11.275 7.524,11.781 7.524,12.4ZM33.399,11.275C32.78,11.275 32.274,11.781 32.274,12.4L32.274,14.65C32.274,15.269 32.78,15.775 33.399,15.775L35.649,15.775C36.268,15.775 36.774,15.269 36.774,14.65L36.774,12.4C36.774,11.781 36.268,11.275 35.649,11.275L33.399,11.275ZM15.399,13.525L15.399,18.025C15.399,19.269 16.404,20.275 17.649,20.275L26.649,20.275C27.893,20.275 28.899,19.269 28.899,18.025L28.899,13.525C28.899,12.28 27.893,11.275 26.649,11.275L17.649,11.275C16.404,11.275 15.399,12.28 15.399,13.525ZM17.649,24.775C16.404,24.775 15.399,25.78 15.399,27.025L15.399,31.525C15.399,32.769 16.404,33.775 17.649,33.775L26.649,33.775C27.893,33.775 28.899,32.769 28.899,31.525L28.899,27.025C28.899,25.78 27.893,24.775 26.649,24.775L17.649,24.775Z",
    style: {
      fill: "#00659d",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.149,
    y: 0.525,
    width: 44,
    height: 44,
    style: {
      fill: "none"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/film.570f7d8689f7dfae87e35e324624a9c9.svg";